if (window._googleAnalytics?.IsActiveGoogleAnalystic) {
  // phần google tag manager ở header
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', window._googleAnalytics?.ContainterId);

  // Google tag (gtag.js) - phần google analystic ở header
  var script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + window._googleAnalytics?.MeasurementId;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', window._googleAnalytics?.MeasurementId);

  // phần google tag manager ở noscript body
  var iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${window._googleAnalytics?.ContainterId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  document.getElementById('noscript-container-gtm').appendChild(iframe);
}
